
import {post,get} from '@/utils/request';
import {erpserver,erpplatserver,attendanceserver} from '@/utils/baseUrl';
import{sse_url} from '@/utils/baseUrl';

// //关闭SSE
// export async function closeSSE(params) {
//     return get(sse_url+'/closeSSE');
// // }
// //文件上传
// export async function closeSSE(params) {
//     return post(sse_url+'/close/'+params.userId)
// }
//Sseguan
export async function closeSSE(params) {

    return post(sse_url+'/close/'+params.userId, params, true)
}
// //打卡列表
// export async function records(params) {
//     return post(sse_url+'/close/file/records', params, true)
// }
//SSEkai
export async function connect(params) {
    return post(erpplatserver+'/sse/connect', params, false)
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
//文件上传
export async function upload(params) {
    return post(attendanceserver+'/attendence/upload', params, false)
}
//导入保存
export async function save(params) {
    return post(attendanceserver+'/attendence/save', params, true)
}
//打卡列表
export async function intervalList(params) {
    return post(attendanceserver+'/attendence/intervalList', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//搜索框模糊查询
export async function searchUser(params) {
    return post(attendanceserver+'/attendence/searchUser', params, true)
}
//搜索框模糊查询
export async function result(params) {
    return post(attendanceserver+'/attendence/result', params, true)
}
//获取班次列表
export async function getbcdetailList(params) {
    return post(attendanceserver+'/kq/getbcdetailList', params, true)
}
//获取报表时间
export async function time(params) {
    return post(attendanceserver+'/attendence/kqtc/time', params, true)
}
//下载明细合计
export async function getExcel(params) {
    return post(attendanceserver+'/attendence/getExcel', params, true)
}
//加班结转
export async function handleOvertime(params) {
    return post(attendanceserver+'/kq/handleOvertime', params, true)
}
export async function nextOvertime(params) {
    return post(attendanceserver+'/kq/nextOvertime', params, true)
}
export async function freeze(params) {
    return post(attendanceserver+'/attendence/freeze', params, true)
}
export async function saveInterval(params) {
    return post(attendanceserver+'/attendence/saveInterval', params, true)
}
